// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__jYtKp","imageWrapper":"Frame_imageWrapper__5rbqd","image":"Frame_image__vWkQY","index":"Frame_index__YZ0me"};